import { NextPage } from 'next';
import ForgotAndResetPassword from 'src/components/ForgotAndResetPassword';

import Layout from '../components/Layout';

const ForgotPassword: NextPage = () => {
  return (
    <Layout>
      <ForgotAndResetPassword isForgotPassword />
    </Layout>
  );
};

export default ForgotPassword;
